<script setup lang="ts">

import PositionIcon from '@/components/Elements/Images/Icons/PositionIcon.vue'
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/**
 * Props
 */
const props = defineProps<{
  shipActionData: {
    action: string;
    targetX: number;
    targetY: number;
    targetPlayer: number;
    targetShip: number;
    data: {
      name: string;
      type: number;
      typeVariantId: number;
      targetPlayer: number;
    }
  },
  eta: number
}>();

</script>

<template>
  <StandardCard top-padding="0" bottom-padding="1">
    <div class="flex justify-between text-subtext w-full">
      <div class="flex gap-4">
        <GenericIcon :tooltip="t('command.ships.current.settle.tooltip')" type="cmd_settle" class="hidden md:inline"/>
        <div class="flex items-center">
          <div class="me-1">{{ t('command.ships.current.settle.settle', { name: shipActionData.data.name }) }}</div><PositionIcon :x="props.shipActionData.targetX" :y="props.shipActionData.targetY"/>
        </div>
      </div>
      <div class="flex-shrink-0 ps-2">
        {{ eta >= 500 ? '500+' : eta }} {{ t('command.ships.current.days') }}
      </div>
    </div>
  </StandardCard>
</template>

<style scoped lang="scss">

</style>